import React from 'react';
import './MyWhatsAppButton.css'; // Create this CSS file
import { FaWhatsapp } from 'react-icons/fa';

const MyWhatsAppButton = () => {
  const phoneNumber = '9605767367'; // Replace with your number
  const message = 'Hello! I have a question.'; // Optional pre-filled message

  return (
    <>
    {/* WhatsApp Floating Button */}
          <a 
            href="https://wa.me/9605767367" 
            className="whatsapp-float"
            target="_blank" 
            rel="noopener noreferrer"
          >
            <FaWhatsapp/>
          </a>
          </>
  );
};

export default MyWhatsAppButton;